import React from "react";
import { useFirebase } from "../../database/FirebaseContext";

function MemberInformationAdmin({ openmodalWorkingTimeGraph, user, index }) {

  const { removeUser } = useFirebase();

  return (
    <div className="w-full h-auto bg-[#404040] rounded-md">
      <div className="flex flex-row items-center">
        <div className="text-white ml-[10px] mr-[3px]">{index + 1}</div>
          <div className="flex-grow">
            <div className="text-white ml-[10px]" onClick={() => openmodalWorkingTimeGraph(user)}>
              {user.userName}
            </div>
          </div>


        <div className="border border-white flex h-auto mt-[10px] mr-[10px] mb-[10px] rounded">
          <div className="flex bg-[#404040] items-center ml-[5px] mr-[5px]">
            <div>
              <i class="fa-solid fa-envelope mr-[5px] text-white"></i>
            </div>
            <div className="text-white">{user.userEmail}</div>
          </div>
        </div>

        <div className="border border-white flex h-auto mt-[10px] mr-[35px] mb-[10px] rounded">
          <div className="flex bg-[#404040] items-center ml-[5px] mr-[5px]">
            <div>
              <i class="fa-solid fa-key mr-[5px] text-white"></i>
            </div>
            <div className="text-white">{user.userPassword}</div>
          </div>
        </div>

        {user.userRole === "Member" && (
          <div className="mr-[15px]">
            <i class="fa-regular fa-trash-can fa-lg list-item-icon text-white" onClick={() => { removeUser(user.id) }}></i>
          </div>
        )}

        {user.userRole === "Admin" && (
          <div className="mr-[28px]" />
        )}

      </div>
    </div>
  );
};

export default MemberInformationAdmin;
